export const assetOverallReport = async ({ firm, list  }) => {
    let pdfDoc = {
        // pageOrientation: 'landscape',
        content: [
            {
                table: {
                    widths: ['30%', '70%' ],
                    body: [
                        [
                            {
                                text: 'ASSET OVERALL REPORT ', style: 'schoolColorHeader2'
                            },

                            {
                                text:
                                    [
                                        { text: '          ', bold: true, style: 'schoolColorHeader' },
                                        { text: '\n', style: 'schoolColorHeader' },
                                    ]
                            },
                        ],
                    ],

                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 2 : 0;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 2 : 0;
                    },
                    hLineColor: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
                    },
                    vLineColor: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
                    },
                }
            },
            {
                table: {
                    headerRows: 1,
                    // widths: ['10%', "*", '10%', '10%', '10%', '10%', '10%'],
                    widths: ['10%', "*", '15%', '15%', '15%', '15%'],
                    body: [
                        [   
                            { text: 'S.No.', style: "schoolColorHeader1" },
                            { text: 'Particulars', style: "schoolColorHeader1" },
                            { text: 'Opening', style: "schoolColorHeader1" },
                            // { text: 'Taxable', style: "schoolColorHeader1" },
                            { text: 'Addition', style: "schoolColorHeader1" },
                            // { text: 'Total', style: "schoolColorHeader1" },
                            { text: 'Depriciation', style: "schoolColorHeader1" },
                            { text: 'Closing', style: "schoolColorHeader1" },
                        ],
                    ]
                },
            },
            {
                table: {
                    widths: ['33%', '34%', '33%'],
                    body: [
                        [
                            {
                                text:
                                    [
                                        { text: '\n\n\n\n' },
                                        { text: 'OFFICE INCHARGE ', bold: true, alignment: 'center',style: 'colorHeader'},
                                        { text: '\n' },                                                                                    
                                    ]
                            },
                        
                            {
                                text:
                                [
                                    { text: '\n\n\n\n' },
                                    { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center',style: 'colorHeader'},
                                    { text: '\n' },
                                ]
                            },

                            {
                                text:
                                    [
                                        { text: '\n\n\n\n' },
                                        { text: 'PRINCIPAL SIGNATURE  ', bold: true, alignment: 'center',style: 'colorHeader'},
                                        { text: '\n' },                                                                                    
                                    ]
                            },
                        ],
                    ],
                
                },
                layout : {
                        hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 2 : 0;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 2 : 0;
                    },
                    hLineColor: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
                    },
                    vLineColor: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
                    },
                }
            },

        ],
        styles: {
            feeHeader: {
                fontSize: 10,
                alignment: 'center'
            },
            feeTableHeader: {
                fontSize: 10,
                alignment: 'center',
                fillColor: '#1A237E',
                color: '#ffffff',
                bold: true,
            },
            feeDescriptiveHeader: {
                fontSize: 10,
                alignment: 'left',
                bold: true,
            },
            feeDescriptiveHeader1: {
                fontSize: 10,
                alignment: 'center',
                bold: true,
            },
            topHeader: {
                color: '#ffffff',
                fontSize: 11,
                alignment: 'left',
                bold: true,
                fillColor: '#1A237E'
            },
            thankyouHeader: {
                color: '#ffffff',
                fontSize: 11,
                alignment: 'center',
                bold: true,
                fillColor: '#1A237E'
            },
            upcomingFeeHeader: {
                color: '#ffffff',
                fontSize: 11,
                alignment: 'left',
                bold: true,
                fillColor: '#1A237E'
            },
            colorHeader: {
                color: '#1A237E',
                fontSize: 12,
                bold: true,
            },
            schoolColorHeader: {
                color: '#1A237E',
                fontSize: 14,
                bold: true,
                alignment: 'right',
            },
            schoolColorHeader1: {
                color: '#1A237E',
                fontSize: 9,
                bold: true,
                alignment: 'center',
            },
            schoolColorHeader2: {
                color: '#1A237E',
                fontSize: 14,
                bold: true,
                alignment: 'left',
            },
            studentDetails: {
                fontSize: 9,
                bold: true,
            },
            studentDetailsRight: {
                fontSize: 9,
                bold: true,
            },
        }
    }

    //school details

    if (firm) {
        pdfDoc.content[0].table.body[0][1].text[1].text = ('BMJ').toUpperCase() + '\n';
    }

    let total = 0;
    let addition = 0;
    let deletion = 0;
    let opening = 0;
    let taxable = 0;
    let closingTotal = 0;
    let depreciationTotal = 0;

    list.map((pro,index) => {
        total += Number.parseFloat(pro.totalAmount);
        taxable += Number.parseFloat(pro.taxableAmount);
        addition += Number.parseFloat(pro.totalAdditionAmount);
        // deletion += Number.parseFloat(pro.deletionAmount);
        opening += Number.parseFloat(pro.openingBalance);

        const openingBalance = parseFloat(pro.openingBalance || 0);
        const totalAdditionAmount = parseFloat(pro.totalAdditionAmount);
        const totalAmount = parseFloat(pro.totalAmount || 0);
        const depriciationRate = parseFloat(pro.depriciation || 0); // % value
        const isVerified = pro.isVerified;

        let depriciation = 0;
        if (isVerified && depriciationRate) {
            depriciation = ((totalAdditionAmount || 0) * depriciationRate) / 100;
        }
        depreciationTotal += depriciation;

        const closing = ((openingBalance + totalAdditionAmount) - depriciation).toFixed(2);
        closingTotal += Number.parseFloat(closing);

        let temp = [
            { text: index + 1, style:'studentDetails'},
            { text: pro.asset, style: 'studentDetailsRight' },
            { text: openingBalance.toFixed(2), style: 'studentDetails' },
            { text: totalAdditionAmount || 0 , style: 'studentDetails' },
            { text: depriciation.toFixed(2), style: 'studentDetails' },
            { text: closing, style: 'studentDetails' },
        ]
     
        pdfDoc.content[1].table.body.push(temp);
    });
    pdfDoc.content[1].table.body.push([
        { text: " ", style: "studentDetails" },
        { text: "Total", style: "studentDetails" },
        { text: Number.parseFloat(opening).toFixed(2), style: "studentDetailsRight" },
        { text: Number.parseFloat(addition).toFixed(2), style: "studentDetailsRight" },
        { text: Number.parseFloat(depreciationTotal).toFixed(2), style: "studentDetails" },    
        { text: Number.parseFloat(closingTotal).toFixed(2), style: "studentDetailsRight" },
    ],)
    return pdfDoc;
}



// WEBPACK FOOTER //
// ./src/utils/pdf-reports/assetOverallReport.js